import { createRoute } from '@tanstack/react-router'

import { createValidateSearch } from '@campai/lib-web/routes'

import { rootRoute } from '@/product/community/root'
import { SearchSchema } from '@/product/community/category/routeUtils'

import { Category } from './Category'

export const categoryRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/categories/$categoryId',
    component: Category,
    validateSearch: createValidateSearch(SearchSchema),
})
